/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var LimitUsage;
(function (LimitUsage) {
    let code;
    (function (code) {
        code["AIR_VIDEO_NON_PUBLIC_LIMIT"] = "AIR_VIDEO_NON_PUBLIC_LIMIT";
        code["FREE_USER_GENERIC_LIMIT"] = "FREE_USER_GENERIC_LIMIT";
        code["VIEW_LINK_LIMIT"] = "VIEW_LINK_LIMIT";
    })(code = LimitUsage.code || (LimitUsage.code = {}));
})(LimitUsage || (LimitUsage = {}));
